import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'dal-shared-ui-search',
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss',
})
export class SearchComponent {
  @Input() SearchLabel = 'Search...';
  @Input() showIcon = true;
  @Input() options: string[] = [];
  @Output() searchEvent = new EventEmitter<string>();
  searchText: string = '';

  search() {
    if (!this.searchText || this.searchText.trim() === '') {
      this.searchText = '%';
    }
    this.searchEvent.emit(this.searchText.trim());
  }
}
